(() => {
  if (customElements.get('niacinamide-cycle-timer')) return;
  const maximum = 9 * 60 * 60;
  const period = 4 * 60 * 60 * 1000;
  function cycleSeconds(now, startedAt) {
    const elapsed = Math.max(0, now - startedAt) % period;
    return Math.ceil(maximum - elapsed / 1000);
  }
  class NiacinamideCycleTimer extends HTMLElement {
    connectedCallback() {
      this.hours = this.querySelector('[data-hours]');
      this.minutes = this.querySelector('[data-minutes]');
      this.seconds = this.querySelector('[data-seconds]');
      const now = Date.now();
      this.startedAt = now;
      try {
        const key = 'smilunora:niacinamide:cycle-9-to-5:v1';
        const saved = Number(localStorage.getItem(key));
        if (Number.isFinite(saved) && saved > 0 && saved <= now) this.startedAt = saved;
        else localStorage.setItem(key, String(now));
      } catch {}
      this.update();
      this.interval = setInterval(() => this.update(), 1000);
    }
    disconnectedCallback() {
      clearInterval(this.interval);
    }
    update() {
      const remaining = cycleSeconds(Date.now(), this.startedAt);
      this.hours.textContent = String(Math.floor(remaining / 3600)).padStart(2, '0');
      this.minutes.textContent = String(Math.floor(remaining % 3600 / 60)).padStart(2, '0');
      this.seconds.textContent = String(remaining % 60).padStart(2, '0');
    }
  }
  customElements.define('niacinamide-cycle-timer', NiacinamideCycleTimer);
})();
